export const NAMESPACE = 'agencySwitcher'
